import { defaultTheme } from '@hn-ui/themes';
export var TestPositionColor = {
    TBD: defaultTheme.colors.black80,
    FAR_BELOW: defaultTheme.colors.red70,
    BELOW: defaultTheme.colors.yellow60,
    MEETS: defaultTheme.colors.green70,
    EXCEEDS: defaultTheme.colors.green30,
};
